export const isValidNumericString = (value: string) => {
  const reg = new RegExp('^[-]?[0-9]+$');

  return !isNaN(Number(value)) && reg.test(value);
};
